module.exports = __webpack_public_path__ + "img/david_thorne_head.c7189fa2.png";